module.exports = __webpack_public_path__ + "img/top-img.d8ca77b0.png";